import { graphql } from 'react-relay/legacy.js';

export const designsRoot = graphql`
    query designsRootQuery {
        viewer {
            iconicDesignsDirectoryPage {
                bannerImages {
                    imageUrl
                }
            }
            ...DesignsLayout_viewer
        }
    }
`;
